import React from 'react';
import { useFetch } from '@/hooks';
import style from './style.module.scss';
import Link from 'next/link';
import { MainNews } from '..';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

type HomeFeedItem = {
  id: number;
  title: string;
  date?: string;
  createdAt: string;
  type: 'analitics' | 'intervyus';
};

export const LastNews = async () => {
  const [analyticsResponse, interviewsResponse] = await Promise.all([
    useFetch(
      process.env.NEXT_PUBLIC_API_URL +
        '/analitikas?populate=*&sort[createdAt]=desc&pagination[pageSize]=50',
    ),
    useFetch(
      process.env.NEXT_PUBLIC_API_URL +
        '/intervyus?populate=*&filters[showOnMainPage][$eq]=true&sort[createdAt]=desc&pagination[pageSize]=50',
    ),
  ]);

  const analytics = analyticsResponse?.data ?? [];
  const interviews = interviewsResponse?.data ?? [];

  if (!analyticsResponse?.data && !interviewsResponse?.data) {
    return 'Ошибка';
  }

  const analyticsFeed: HomeFeedItem[] = analytics
    .map((item: Omit<HomeFeedItem, 'type'>) => ({
      ...item,
      type: 'analitics' as const,
    }))
    .sort((a, b) => dayjs(b.date ?? b.createdAt).valueOf() - dayjs(a.date ?? a.createdAt).valueOf());

  const interviewsFeed: HomeFeedItem[] = interviews
    .map((item: Omit<HomeFeedItem, 'type'>) => ({
      ...item,
      type: 'intervyus' as const,
    }))
    .sort((a, b) => dayjs(b.date ?? b.createdAt).valueOf() - dayjs(a.date ?? a.createdAt).valueOf());

  const homeFeed: HomeFeedItem[] = [...interviewsFeed, ...analyticsFeed].slice(0, 5);

  return (
    <div className={style.news}>
      <div className={style.content}>
        <MainNews/>
        <div className={style.right}>
          {homeFeed.map((elem) => {
            return (
              <Link key={`${elem.type}-${elem.id}`} href={`/${elem.type}/${elem.id}`} className={style.element}>
                <h3 className={style.title}>
                  {elem?.title.length > 100 ? `${elem?.title.slice(0, 100)}...` : elem?.title}
                </h3>
                <p className={style.date}>
                  <span>{dayjs(elem.date ?? elem.createdAt).format('DD.MM')}</span>
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};
